import { guardianApiClient } from './guardian';
import { Notification, PaginatedResponse } from '../../types/api';
import { NotificationFilters } from './notifications';

const BASE = '/guardians/portal/notifications';

export const guardianNotificationsApi = {
  async getNotifications(
    filters?: NotificationFilters
  ): Promise<PaginatedResponse<Notification>> {
    const params = new URLSearchParams();
    if (filters?.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters?.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters?.is_read !== undefined) params.append('is_read', filters.is_read.toString());
    if (filters?.type) params.append('type', filters.type);
    const response = await guardianApiClient.get(`${BASE}/?${params.toString()}`);
    const data = response.data;
    const items: Notification[] = Array.isArray(data) ? data : data.items || [];
    const total: number = data.total ?? items.length;
    return {
      items,
      total,
      page: 1,
      size: items.length,
      pages: 1,
    };
  },

  async getUnreadCount(): Promise<{ count: number }> {
    const response = await guardianApiClient.get(`${BASE}/unread-count`);
    return response.data;
  },

  async markAsRead(id: string): Promise<void> {
    await guardianApiClient.put(`${BASE}/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await guardianApiClient.put(`${BASE}/read-all`);
  },

  async deleteNotification(id: string): Promise<void> {
    await guardianApiClient.delete(`${BASE}/${id}`);
  },
};
